import ServiceCollection from "src/services/ServiceCollection";
import React, { useEffect } from "react";
import { accountingDaysList } from "src/models/reports/GetAccountingDayList"
import { Autosuggest, FormField, Select, SelectProps } from '@amzn/awsui-components-react/polaris';
import { ColumnLayout } from "@amzn/awsui-components-react";

type ComponentProps = {
    services: ServiceCollection,
    selectedAccountingPeriod: SelectProps.Option | null,
    selectedAccountingDay: SelectProps.Option | null,
    tpTaxOwner?: string,
    tpTaxOwnerOptions?: string[],
    onAccountingPeriodSelected: (option: SelectProps.Option | null) => void,
    onAccountingDaySelected: (option: SelectProps.Option | null) => void,
    onTpTaxOwnerChanged?: (value: string) => void
}

export default function ReportMetricsDashboardFilterSelector(props: ComponentProps) {
    const {
        services,
        selectedAccountingPeriod,
        selectedAccountingDay,
        tpTaxOwner,
        tpTaxOwnerOptions,
        onAccountingPeriodSelected,
        onAccountingDaySelected,
        onTpTaxOwnerChanged
    } = props;

    const [accountingPeriodResult, accountingPeriodLoading, accountingPeriodError] = services.reportsService.getReportingPeriods();

    useEffect(() => {
        if (!accountingPeriodError) {
            return;
        }
        services.messageService.showErrorAutoDismissBanner(accountingPeriodError);
    }, [accountingPeriodError])

    return (
        <ColumnLayout columns={onTpTaxOwnerChanged ? 3 : 2}>
            <FormField label="Accounting Period">
                <Select
                    statusType={accountingPeriodLoading ? "loading" : "finished"}
                    loadingText="Fetching available options"
                    selectedOption={{
                        label: selectedAccountingPeriod?.label,
                        value: selectedAccountingPeriod?.value
                    }}
                    onChange={({ detail }) =>
                        onAccountingPeriodSelected(detail.selectedOption)
                    }
                    options={
                        accountingPeriodResult == null
                            ? []
                            : accountingPeriodResult.ReportingPeriodList.map(
                                (accountingPeriodNameValue) => ({
                                    label: accountingPeriodNameValue,
                                    value: accountingPeriodNameValue,
                                })
                            )
                    }
                    placeholder="Select the accounting period"
                    virtualScroll={true}
                    filteringType="auto"
                />
            </FormField>
            <FormField label="Accounting Day">
                <Select
                    selectedOption={
                        {
                            label: selectedAccountingDay?.label,
                            value: selectedAccountingDay?.value
                        }
                    }
                    options={accountingDaysList}
                    onChange={({ detail }) => {
                        onAccountingDaySelected(detail.selectedOption);
                    }}
                    selectedAriaLabel="Selected"
                    placeholder="Select Accounting Day"
                />
            </FormField>
            {onTpTaxOwnerChanged && (
                <FormField label="TP Tax Owner">
                    <Autosuggest
                        value={tpTaxOwner || ''}
                        onChange={({ detail }) => onTpTaxOwnerChanged(detail.value)}
                        options={(tpTaxOwnerOptions || []).map((owner) => ({ value: owner }))}
                        enteredTextLabel={(value) => `Use: "${value}"`}
                        placeholder="Filter by TP Tax Owner"
                        empty="No matching TP Tax Owner"
                    />
                </FormField>
            )}
        </ColumnLayout>
    );
}
